<template>
  <div class="care-practice-section">
    <div class="care-practice-section__bg">
      <img
        :src="
          isMobile
            ? '/media/img/products/care/section-5-m.png'
            : '/media/img/products/care/section-5.png'
        "
      />
      <div class="care-practice-section__bg-icons">
        <img
          :src="isMobile
            ? '/media/img/products/care/section-5-2-m.png'
            : '/media/img/products/care/section-5-2.png'"
        />
      </div>
    </div>
    <div class="care-practice-section__main container">
      <div class="care-practice-section__content">
        <div class="care-practice-section__title">
          {{$t('care.sectionFloorStand.title')}}
        </div>
        <p class="care-practice-section__description">
          {{$t('care.sectionFloorStand.desc')}}
        </p>
        <a
          class="care-practice-section__link"
          href="https://support.lollipop.camera/hc/en-us/articles/900000772266-How-to-Make-Breathing-Detection-and-Sleep-Tracking-Work-Properly-"
          target="_blank"
        >
          {{$t('care.sectionFloorStand.linkText')}}
        </a>
        <a
          class="care-practice-section__button btn btn-learn-more"
          :href="floorStandLeranMoreLink"
          target="_blank"
        >
          {{$t('care.sectionFloorStand.discount')}}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CarePracticeSection',
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile,
      languageCode: (state) => state.languageCode,
    }),
    floorStandLeranMoreLink() {
      return this.languageCode !== 'zh-Hant'
        ? 'https://shop.lollipop.camera/discount/LOLISTAND20?redirect=%2Fproducts%2Flollipop-floor-stand'
        : 'https://shopee.tw/Lollipop%E5%AC%B0%E5%85%92%E7%9B%A3%E8%A6%96%E5%99%A8%E7%AB%8B%E6%9E%B6-160cm-i.63372023.19364316525';
    },
  },
};
</script>

<style lang="sass" scoped>
.container
  width: 100%;
  padding: 0 9vw;

  @media screen and (max-width: 1440px)
    padding: 0 3vw;

  @media screen and (max-width: 414px)
    padding: 0 30px;

  @media screen and (max-width: 375px)
    padding: 0 25px;

.care-practice-section
  width: 100%
  height: 100%
  pointer-events: none
  opacity: 0
  transition: opacity 0.5s ease-in-out

  .page-care__scroll.active-4 &,
    transition: opacity 0.5s 0.5s ease-in-out
    pointer-events: auto
    opacity: 1

  &__main
    width: 100%
    height: 100%
    display: flex
    justify-content: center
    flex-direction: column

    @media screen and (orientation: portrait), (max-width: 768px)
      justify-content: flex-end

  &__bg
    position: absolute
    bottom: 0
    left: 8vw
    width: 520px
    pointer-events: none
    overflow: hidden

    @media screen and (max-width: 1440px)
      width: 350px

    @media screen and (max-width: 1440px)
      left: 4vw

    @media screen and (orientation: portrait), (max-width: 375px)
      width: 190px
      bottom: auto
      top: 0
      left: 50%
      overflow: visible
      transform: translate(-50%, 0%) translate(-40%);

    > img
      width: 100%
      transform: translate(0, 50%);
      transition: transform 0.5s ease-in-out

      @media screen and (max-width: 1440px)
        transform: translate(0, 45%);

      @media screen and (orientation: portrait), (max-width: 375px)
        transform: translate(0, 5%);

      .page-care__scroll.active-4 &
        transform: translate(0, 45%);
        transition: all 0.5s 0.5s ease-in-out

        @media screen and (max-width: 1440px)
          transform: translate(0, 40%);

        @media screen and (orientation: portrait), (max-width: 375px)
          transform: translate(0, 0);

    &-icons
      position: absolute
      bottom: 20%
      right: 20%
      width: 62px;

      @media screen and (max-width: 1440px)
        width: 60px;
        bottom: 15%
        right: 20%

      @media screen and (orientation: portrait), (max-width: 768px)
        width: 180px;
        bottom: auto
        top: 17%
        right: 0
        transform: translate(50%, 0);

      img
        width: 100%

  &__content
    width: 850px
    position: absolute
    top: 50%;
    left: 50%
    transform: translate(-50%, -50%) translate(30%, 90%)

    @media screen and (min-width: 1366px)
      transform: translate(-50%, -50%) translate(25%, 87%)
      display: inline-flex
      flex-direction: column
      align-items: center

    @media screen and (max-width: 1024px)
      max-width: 560px
      transform: translate(-50%, -50%) translate(28%, 80%)

    @media screen and (orientation: portrait), (max-width: 768px)
      width: 100%
      position: relative
      top: 0%
      left: auto
      transform: none
      margin: 40px auto 220px
      flex: 1 1 auto
      margin: 400px auto 0

    @media screen and (max-width: 414px)
      margin-top: 350px

    @media screen and (max-width: 375px)
      margin: 310px auto 0
      position: relative
      transform: translate(0, 5%);
      transition: transform 0.5s ease-in-out

      .page-care__scroll.active-4 &
        transform: none;
        transition: transform 0.5s 0.5s ease-in-out

  &__title
    font-size: 40px
    margin-bottom: 24px
    @media screen and (min-width: 1366px)
      white-space: nowrap
      text-align: center
    @media screen and (max-width: 1440px)
      font-size: 32px
      margin-bottom: 16px

    @media screen and (max-width: 1024px)
      font-size: 24px

    @media screen and (orientation: portrait), (max-width: 768px)
      font-size: 20px
      justify-content: center
      margin-bottom: 12px

    @media screen and (orientation: portrait), (max-width: 375px)
      margin-bottom: 8px

  &__description
    font-size: 24px
    margin-bottom: 24px

    @media screen and (max-width: 1440px)
      font-size: 18px
      margin-bottom: 16px

    @media screen and (max-width: 1024px)
      font-size: 16px

    @media screen and (orientation: portrait), (max-width: 375px)
      margin-bottom: 25px
      font-size: 16px

  &__link
    display: block;
    margin-bottom: 16px
    text-decoration: underline
    font-size: 20px

    @media screen and (max-width: 1440px)
      font-size: 14px
</style>
